module.exports = __webpack_public_path__ + "static/img/trazdia.3331d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/trazdia.png
// module id = iBtO
// module chunks = 0